import React from 'react';
import moment from 'moment';

const TablaMantenimiento = props => (
  <tbody>
    {
      props.lugares.length ?
        props.lugares.map(lugar => (
          <tr key={lugar.codConfPlanEntr}>
            <td>{lugar.codConfPlanEntr}</td>
            <td>{lugar.desFamVeh}</td>
            <td>{lugar.nomFilial}</td>
            <td>{lugar.indFlota === 'N' ? 'No' : 'Sí'}</td>
            <td>{lugar.canMaxiUni}</td>
            <td>{lugar.codTipoDia === 'D' ? 'Diario' : 'Semanal'}</td>
            <td>{lugar.horaIniEntr ? moment(lugar.horaIniEntr).format('HH:mm') : ''}</td>
            <td>{lugar.horaMaxEntr ? moment(lugar.horaMaxEntr).format('HH:mm') : ''}</td>
            <td>{lugar.horaIniLocked ? moment(lugar.horaIniLocked).format('HH:mm') : ''}</td>
            <td>{lugar.horaFinLocked ? moment(lugar.horaFinLocked).format('HH:mm') : ''}</td>
            <td>{lugar.numHorasReservada}</td>
            <td>{lugar.indParalelo === 'N' ? 'No' : 'Sí'}</td>
            <td>{lugar.cantVehParalelo}</td>
            <td>{lugar.indInactivo === 'N' ? 'No' : 'Sí'}</td>
            <td>
              <button className='btn btn-blue' onClick={() => props.openModal('mantenimiento', lugar)}>Editar</button>
            </td>
          </tr>
        )) :
        <tr>
          <td colSpan={15}>No hay resultados</td>
        </tr>
    }
  </tbody>
);

export default TablaMantenimiento;



// WEBPACK FOOTER //
// ./src/pages/MantLugarEntrega/TablaMantenimiento.js